<template>

    <div class="item-desktop noselect" :class="{'item-desktop-checked': item.checked}" @click="toggleItem">
        <div class="top">
            <img
                :src="item.checked ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'"
                class="checkbox">
            <div class="texts">
                <div class="row">
                    <img class="later"
                         src="/img/newsletters-v2/later-blue.svg"
                         v-if="item.type === ENUM.NEWSLETTERS.CATEGORIES.LATER"
                         :data-highlight="ENUM.HIGHLIGHT.NEW_SENDER">
                    <span class="text-lMedium ellipsis-text">{{ item.name }}</span>
                </div>
                <span class="text-baseRegular color__moon mt__2 ellipsis-text">{{ item.sender }}</span>
            </div>
        </div>
        <div class="bottom">
            <div class="first-line">
                <img src="/img/icons/newsletter-fill-green.svg" class="img__16 mr__4">
                <span
                    class="text-sRegular color__moon mr__16"> {{ $tc('mail_received', item.count, {number: item.count}) }}</span>
                <img src="/img/icons/newsletter-open-green.svg" class="img__16 mr__4">
                <span
                    class="text-sRegular color__moon">{{ $tc('mail_opened', item.openRate, {number: `${item.openRate}%`}) }}</span>
            </div>
            <div class="second-line">
                <span class="label-orange text-sMedium"
                      v-show="item.notSeen"
                      :data-highlight="item.notSeen ? ENUM.HIGHLIGHT.NOT_SEEN : ''"
                >{{ $t('new_mail_received') }}</span>
            </div>
        </div>
    </div>

</template>

<script>

export default {

    name: 'list-item-desktop',

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    methods: {
        toggleItem() {
            this.item.checked = !this.item.checked
        }
    }
}
</script>

<style lang="scss" scoped>

.item-desktop {
    max-width: 460px;
    width: 100%;
    cursor: pointer;
    margin-top: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    background-color: $white;
    border-radius: 16px;
    border: 1px solid $platinum;

    .top {
        display: flex;
        flex-direction: row;
        align-items: center;

        .checkbox {
            width: 24px;
            margin-right: 16px;
            &:lang(ar-sa) {
                margin-right: 0;
                margin-left: 16px;
            }
        }

        .texts {
            display: flex;
            flex-direction: column;
            text-align: start;
            overflow: hidden;

            .row {
                display: flex;
                flex-direction: row;

                .later {
                    width: 20px;
                    object-fit: contain;
                    margin-right: 8px;
                    &:lang(ar-sa) {
                        margin-right: 0;
                        margin-left: 8px;
                    }
                }
            }
        }

    }

    .bottom {
        margin-top: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .first-line {
            display: flex;
            text-align: start;
            margin-top: 12px;
        }

        .second-line {
            margin-top: 12px;
        }

        .label-orange {
            border-radius: 16px;
            background: $chardon;
            color: $sunset;
            padding: 4px 8px;
        }
    }
}

.item-desktop-checked {
    background-color: $alice-blue-lighter;
    border-color: $aquamarine;
}

</style>
